module.exports = "/_next/static/images/raffle-ticket-5728a953066cf363f4a1fe9e1da5cba6.png";